import { localize } from 'vee-validate';
import { getCurrentStoredUser } from '@/modules/user/user.service';
import { getCookie, setCookie } from '@/helpers/cookies';
import i18n from '@/config/i18n';

function setCookieLanguage(language) {
  return setCookie('language', language);
}

export function getCookieLanguage() {
  return getCookie('language') === undefined ? 'en' : getCookie('language');
}

export function translate(term) {
  const user = getCurrentStoredUser();
  const language = user ? user.language : i18n.locale;
  return i18n.messages[language][term];
}

export function setLanguage(language) {
  i18n.locale = language;
  localize(language);
  setCookieLanguage(language);
}
